export const CloseIframeMessageType = 'CLOSE_IFRAME';
export const DeviceTypeSearchParamType = 'device_type';
export const BrandSearchParamType = 'brand';
export const VehicleTypeSearchParamType = 'vehicle_type';
export const ExistingAssetIdSearchParamType = 'existing_asset_id';
export const StepSearchParamType = 'step';
export const TestAppSearchParamType = 'test-app';
export const SkipUpsellingSearchParamType = 'skip_upselling';
